import ChecklistColor from './ChecklistColour.svg';
import ChecklistDark from './ChecklistDark.svg';
import ChecklistLight from './ChecklistLight.svg';
export const checklist = { color: ChecklistColor, dark: ChecklistDark, light: ChecklistLight };
//# sourceMappingURL=index.js.map